// src/services/api.js
// Point central pour toutes les communications avec le backend

import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
});

// Ajoute automatiquement le token JWT à chaque requête
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
